import React from "react";
import { Link } from "react-router-dom";
import "./ProjectCard.css";

const ProjectCard = ({ project }) => {
  return (
    <Link
      to={{ pathname: project.github }}
      target={"_blanks"}
      className="pcard-wrapper"
    >
      <h2 className="p-name">{project.name}</h2>
      <p className="p-description">{project.description}</p>
      <div className="p-tags">
        {project.tags.map((tag) => (
          <span className="p-tag">{tag}</span>
        ))}
      </div>
    </Link>
  );
};

export default ProjectCard;
